var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSitemapicon = function SvgSitemapicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.6 11.2h1.6a.8.8 0 0 1 .8.8v3.2a.8.8 0 0 1-.8.8h-4.8a.8.8 0 0 1-.8-.8V12a.8.8 0 0 1 .8-.8H12V8.8H4v2.4h1.6a.8.8 0 0 1 .8.8v3.2a.8.8 0 0 1-.8.8H.8a.8.8 0 0 1-.8-.8V12a.8.8 0 0 1 .8-.8h1.6V8.8A1.6 1.6 0 0 1 4 7.2h3.2V4.8H5.6a.8.8 0 0 1-.8-.8V.8a.8.8 0 0 1 .8-.8h4.8a.8.8 0 0 1 .8.8V4a.8.8 0 0 1-.8.8H8.8v2.4H12a1.6 1.6 0 0 1 1.6 1.6v2.4Zm-4-9.6H6.4v1.6h3.2V1.6ZM4.8 14.4H1.6v-1.6h3.2v1.6Zm6.4 0h3.2v-1.6h-3.2v1.6Z",
    clipRule: "evenodd"
  })));
};
export default SvgSitemapicon;